import { color as bizColor } from "@moneyforward/mfx_biz_react_components";

export const color = {
  // TODO 最終的にはbizColorのみになる想定
  ...bizColor,
  limeade: "#D3D95F",
  aspenGold: "#FFD662",
  white: "#FFFFFF",
  matteCharcoal: "#3B4248",
  madison: "#90B1E0",
  carnation: "#FA4B62",
  guardsmanRed: "#D50000",
  pippin: "#FFE5E6",
  wildSand: "#F5F5F5",
  black: "#030303",
  lightBlack: "#030303",
  boulder: "#757575",
  curiousBlue: "#1991EB",
  silver: "#BDBDBD",
  gallery: "#EAEAEA",
  tahitiGold: "#F4810B",
  iron: "#DADEDF",
  cherub: "#FBE6E6",
  chestnutRose: "#D04E4E",
  nevada: "#626F78",
  mandysPink: "#F2B3B3",
  alto: "#E0E0E0",
  lightGray: "#F1F3F4",
  bondiBlue: "#0085B5",
  link: "#0645AD",
  middleGray: "#D3D3D3",
  backgroundGray: "#00000080",
};

export const theme = {
  primaryTextColor: color.black,
  mainBgColor: color.white,
  headerBgColor: color.white,
};

export const zIndex = {
  globalHeader: 10,
};

// デザイナーからの指示でブレイクポイントを830にする(2022/06/15)
export const spModeBreakPoint = 839;
